module.exports = __webpack_public_path__ + "static/media/13.0a7b8b97.jpg";